@if (active) {
  <kendo-window (close)="closeForm()" [title]="reportId ? 'Edit Record' : 'Add New Record'"
    (stateChange)="onStateChanges($event)" class="forecastForm standardForecastWindow">
    <form [formGroup]="form" class="forecast-form-layout">
      <div class="forecast-form-body">
        <!-- STEPPER SECTION -->
        <div class="col-12" style="padding: 0;">
          <div class="bordered_sections stepperSection">
            <div class="col-12 import_title">Follow the Steps</div>
            <kendo-stepper [steps]="steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false"
              (stepSelect)="goToStep($event.index)">
            </kendo-stepper>
          </div>
        </div>
        <div class="row addNewForecastForm numericboxtab">
          <!-- STEPS 1 & 2 -->
          <div class="col-12">
            <div class="row stepsRowMargin">
              <!-- STEP 1: FORECAST TYPE -->
              <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(0)">
                <div class="row">
                  <div class="col-12">
                    <p class="step_title" (click)="goToStep(0)">Step 1: <span class="stepDescription">forecast type</span></p>
                  </div>
                  <div class="col-12">
                    <div class="bordered_sections_special min-height-section" [class.active-step-forcast]="currentStep === 0" (click)="goToStep(0)">
                      @if (currentStep !== 0) {
                        <div class="forcast-overlay" (click)="goToStep(0)"></div>
                      }
                      <div class="form-group">
                        <label class="control-label trl" for="forecastType">Forecast type</label>
                        <input [disabled]="currentStep != 0" type="text" class="k-textbox writebox" formControlName="forecastType" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- STEP 2: FORECAST NAME -->
              <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(1)">
                <div class="row">
                  <div class="col-12">
                    <p class="step_title" (click)="goToStep(1)">Step 2: <span class="stepDescription">forecast name</span></p>
                  </div>
                  <div class="col-12">
                    <div class="bordered_sections_special bordered_sections_special_right min-height-section"
                      [class.active-step-forcast]="currentStep === 1" (click)="goToStep(1)">
                      @if (currentStep !== 1) {
                        <div class="forcast-overlay" (click)="goToStep(1)"></div>
                      }
                      <div class="form-group">
                        <label class="control-label trl" for="forecastName">Forecast name</label>
                        <input [disabled]="currentStep != 1" type="text" class="k-textbox writebox" formControlName="forecastName"
                          placeholder="Forecast name" required />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- STEPS 3 & 4 -->
            <div class="col-12">
              <div class="row stepsRowMargin">
                <!-- STEP 3: SCOPE & METHOD -->
                <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(2)">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title" (click)="goToStep(2)">Step 3: <span class="stepDescription">choose transaction scope & method</span></p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special minHeightSection" [class.active-step-forcast]="currentStep === 2" (click)="goToStep(2)">
                        @if (currentStep !== 2) {
                          <div class="forcast-overlay" (click)="goToStep(2)"></div>
                        }
                        <div class="row">
                          <!-- Transaction Basis Radio -->
                          <div class="col-12 col-sm-6 margin_button_10">
                            <label class="k-radio-label forecastRadioLabel">
                              receive transaction
                            </label>
                            <input [disabled]="currentStep != 2" type="radio" kendoRadioButton formControlName="basis" [value]="0"
                              (change)="onBasisChange(0)" />
                            </div>
                            <div class="col-12 col-sm-6 leftBorder margin_button_10">
                              <div class="row">
                                <div class="col-12">
                                  <label class="k-radio-label forecastRadioLabel">
                                    issue transaction
                                  </label>
                                  <input [disabled]="currentStep != 2" type="radio" kendoRadioButton formControlName="basis" [value]="1"
                                    (change)="onBasisChange(1)" />
                                  </div>
                                  @if (form.get('basis')?.value === 1) {
                                    <div class="col-12 margin-top-5">
                                      <input [disabled]="currentStep != 2" type="checkbox" kendoCheckBox formControlName="accountForReturns" id="chkReturn" />
                                      <label class="k-radio-label forecastCheckboxLabel" for="chkReturn" style="margin-left: 6px;">
                                        account for returns
                                      </label>
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="inSectionsSeparators"></div>
                              </div>
                              <!-- Items / SKUs Selection -->
                              <div class="col-12 margin_button_10">
                                <div class="d-flex justify-content-between align-items-center">
                                  <label class="control-label trl">Select item(s)</label>
                                  <div>
                                    <input [disabled]="currentStep != 2" type="checkbox" kendoCheckBox formControlName="allSKUs" id="allSKUs"
                                      (change)="onAllSKUsToggle($safeNavigationMigration(form.get('allSKUs')?.value))" />
                                      <label class="k-radio-label forecastCheckboxLabel" for="allSKUs" style="margin-left: 4px;">All Items</label>
                                    </div>
                                  </div>
                                  @if (!form.get('allSKUs')?.value) {
                                    <kendo-multiselect [data]="filteredSkuList" [filterable]="true"
                                      (filterChange)="handleItemFilter($event)" [textField]="'stockNumber'"
                                      [valueField]="'stockId'" [valuePrimitive]="true" formControlName="selectedItems"
                                      placeholder="Choose SKU(s)..." class="reportviewerMS addNewForecastMS" [disabled]="currentStep != 2">
                                    </kendo-multiselect>
                                  }
                                </div>
                                <!-- Vendor Selection (Receiving) -->
                                @if (form.get('basis')?.value === 0) {
                                  <div class="col-12 margin_button_10">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <label class="control-label trl">Select vendor(s)</label>
                                      <div>
                                        <input [disabled]="currentStep != 2" type="checkbox" kendoCheckBox formControlName="allVendors" id="allVendors"
                                          (change)="onAllVendorsToggle($safeNavigationMigration(form.get('allVendors')?.value))" />
                                          <label class="k-radio-label forecastCheckboxLabel" for="allVendors" style="margin-left: 4px;">All Vendors</label>
                                        </div>
                                      </div>
                                      @if (!form.get('allVendors')?.value) {
                                        <kendo-multiselect [data]="filteredVendorList" [filterable]="true"
                                          (filterChange)="handleVendorFilter($event)" [textField]="'vendorCode'" [valueField]="'vendorId'" [valuePrimitive]="true"
                                          formControlName="selectedVendors" placeholder="Choose Vendor(s)..."
                                          class="reportviewerMS addNewForecastMS" [disabled]="currentStep != 2">
                                        </kendo-multiselect>
                                      }
                                    </div>
                                  }
                                  <!-- Customer Selection (Issuing) -->
                                  @if (form.get('basis')?.value === 1) {
                                    <div class="col-12 margin_button_10">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <label class="control-label trl">Select customer(s)</label>
                                        <div>
                                          <input [disabled]="currentStep != 2" type="checkbox" kendoCheckBox formControlName="allCustomers" id="allCustomers"
                                            (change)="onAllCustomersToggle($safeNavigationMigration(form.get('allCustomers')?.value))" />
                                            <label class="k-radio-label forecastCheckboxLabel" for="allCustomers" style="margin-left: 4px;">All Customers</label>
                                          </div>
                                        </div>
                                        @if (!form.get('allCustomers')?.value) {
                                          <kendo-multiselect [data]="filteredCustomerList" [filterable]="true"
                                            (filterChange)="handleCustomerFilter($event)" [textField]="'customerCode'" [valueField]="'customerId'" [valuePrimitive]="true"
                                            formControlName="selectedCustomers" placeholder="Choose Customer(s)..."
                                            class="reportviewerMS addNewForecastMS" [disabled]="currentStep != 2">
                                          </kendo-multiselect>
                                        }
                                      </div>
                                    }
                                    <!-- Method Selection -->
                                    <div class="col-12 margin_button_10">
                                      <label class="control-label trl">Forecast method</label>
                      <kendo-dropdownlist [disabled]="currentStep != 2" formControlName="methodId" [data]="[
                          { text: 'Moving Average', value: 1 },
                          { text: 'Straight Line with Factor', value: 2 }
                        ]" [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true"
                                        class="reportviewerMS addNewForecastMS">
                                      </kendo-dropdownlist>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- STEP 4: METHOD PARAMETERS -->
                          <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(3)">
                            <div class="row">
                              <div class="col-12">
                                <p class="step_title" (click)="goToStep(3)">Step 4: <span class="stepDescription">choose method parameters</span></p>
                              </div>
                              <div class="col-12">
                                <div class="bordered_sections_special bordered_sections_special_right minHeightSection"
                                  [class.active-step-forcast]="currentStep === 3" (click)="goToStep(3)">
                                  @if (currentStep !== 3) {
                                    <div class="forcast-overlay" (click)="goToStep(3)"></div>
                                  }
                                  <!-- METHOD 1: MOVING AVERAGE -->
                                  @if (form.get('methodId')?.value === 1) {
                                    <div class="row">
                                      <div class="col-12">
                                        <div class="sectionsHeadTitle">Moving Average Settings</div>
                                      </div>
                                      <div class="col-12 col-sm-6 margin_button_10">
                                        <label class="control-label trl normalfont">Interval</label>
                                        <kendo-dropdownlist [disabled]="currentStep != 3" formControlName="intervalType"
                                          [data]="[{ text: 'Month', value: 'months' }]" [textField]="'text'" [valueField]="'value'"
                                          [valuePrimitive]="true" class="k-textbox writebox">
                                        </kendo-dropdownlist>
                                      </div>
                                      <div class="col-12 col-sm-6 margin_button_10">
                                        <label class="control-label trl normalfont">Previous months</label>
                                        <kendo-numerictextbox [disabled]="currentStep != 3" formControlName="intervalValue"
                                          [min]="1" [max]="100" [format]="'n0'" class="k-numerictextbox">
                                        </kendo-numerictextbox>
                                      </div>
                                      <div class="col-12">
                                        <div class="inSectionsSeparators"></div>
                                      </div>
                                      <div class="col-12">
                                        <div class="sectionsHeadTitle">Date Settings</div>
                                      </div>
                                      <div class="col-12 margin_button_10">
                                        <label class="k-radio-label trl normalfont" for="nextDate">Next possible date</label>
                                        <input [disabled]="currentStep != 3" type="checkbox" kendoCheckBox formControlName="nextPossibleDate"
                                          id="nextDate" (change)="onNextPossibleDateToggle($safeNavigationMigration(form.get('nextPossibleDate')?.value))" />
                                        </div>
                                        @if (!form.get('nextPossibleDate')?.value) {
                                          <div class="col-12 margin_button_10">
                                            <label class="control-label trl normalfont">Start forecast on</label>
                                            <kendo-datepicker [disabled]="currentStep != 3" formControlName="forecastStart"
                                              [bottomView]="'year'" [topView]="'decade'" [format]="'MMMM yyyy'">
                                            </kendo-datepicker>
                                          </div>
                                        }
                                        <div class="col-12 margin_button_10">
                                          <label class="control-label trl normalfont">Forecast for (months)</label>
                                          <kendo-numerictextbox [disabled]="currentStep != 3" formControlName="forecastFor"
                                            [min]="1" [max]="100" [format]="'n0'" class="k-numerictextbox">
                                          </kendo-numerictextbox>
                                        </div>
                                      </div>
                                    }
                                    <!-- METHOD 2: STRAIGHT LINE WITH FACTOR -->
                                    @if (form.get('methodId')?.value === 2) {
                                      <div class="row">
                                        <div class="col-12">
                                          <div class="sectionsHeadTitle">Factor Rate Settings</div>
                                        </div>
                                        <div class="col-12 margin_button_10">
                                          <input [disabled]="currentStep != 3" type="checkbox" kendoCheckBox formControlName="useCalculatedFactor"
                                            id="useCalc" (change)="onUseCalculatedFactorChange($safeNavigationMigration(form.get('useCalculatedFactor')?.value))" />
                                            <label class="k-checkbox-label forecastCheckboxLabel" for="useCalc" style="margin-left: 6px;">
                                              Use Calculated Factor & Sales History
                                            </label>
                                          </div>
                                          @if (form.get('useCalculatedFactor')?.value) {
                                            <div class="col-12 margin_button_10">
                                              <label class="control-label trl normalfont">Sales history (1 - 12 Months)</label>
                                              <kendo-numerictextbox [disabled]="currentStep != 3" formControlName="salesHistory"
                                                [min]="1" [max]="12" [format]="'n0'" class="k-numerictextbox">
                                              </kendo-numerictextbox>
                                            </div>
                                          }
                                          @if (!form.get('useCalculatedFactor')?.value) {
                                            <div class="col-12 margin_button_10">
                                              <label class="control-label trl normalfont">Custom factor % (e.g., 115%)</label>
                                              <kendo-numerictextbox [disabled]="currentStep != 3" formControlName="customFactor"
                                                [min]="1" [max]="500" [format]="'n2'" class="k-numerictextbox">
                                              </kendo-numerictextbox>
                                            </div>
                                          }
                                          <div class="col-12">
                                            <div class="inSectionsSeparators"></div>
                                          </div>
                                          <div class="col-12">
                                            <div class="sectionsHeadTitle">Target Forecast Year</div>
                                          </div>
                                          <div class="col-12 margin_button_10">
                                            <label class="k-radio-label trl normalfont">
                                              <input [disabled]="currentStep != 3" type="radio" kendoRadioButton formControlName="currentForecastYear" [value]="true" />
                                              Current year
                                            </label>
                                            <label class="k-radio-label trl normalfont" style="margin-left: 20px;">
                                              <input [disabled]="currentStep != 3" type="radio" kendoRadioButton formControlName="currentForecastYear" [value]="false" />
                                              Next year
                                            </label>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- STEPS 5 & 6 -->
                          <div class="col-12">
                            <div class="row stepsRowMargin">
                              <!-- STEP 5: VARIANCE (OPTIONAL) -->
                              <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(4)">
                                <div class="row">
                                  <div class="col-12">
                                    <p class="step_title" (click)="goToStep(4)">
                                      Step 5: <span class="stepDescription">choose variance</span><span class="optionalStyle"> - optional</span>
                                    </p>
                                  </div>
                                  <div class="col-12">
                                    <div class="bordered_sections_special minHeightSection" [class.active-step-forcast]="currentStep === 4" (click)="goToStep(4)">
                                      @if (currentStep !== 4) {
                                        <div class="forcast-overlay" (click)="goToStep(4)"></div>
                                      }
                                      <div class="row">
                                        <div class="col-12 margin_button_10">
                                          <label class="control-label trl" for="overage">overage/shrinkage</label>
                                          <kendo-numerictextbox [disabled]="currentStep != 4" formControlName="overageShrinkage"
                                            [min]="-100" [max]="100" [format]="'n2'" class="k-numerictextbox"
                                            (valueChange)="onOverageChange($event)">
                                          </kendo-numerictextbox>
                                        </div>
                                        <div class="col-12 margin_button_10">
                                          <label class="control-label trl" for="replenish">replenish</label>
                                          <kendo-numerictextbox [disabled]="currentStep != 4" formControlName="replenish"
                                            [min]="0" [max]="100" [format]="'n2'" class="k-numerictextbox"
                                            (valueChange)="onReplenishChange($event)">
                                          </kendo-numerictextbox>
                                        </div>
                                        <div class="col-12">
                                          <div class="inSectionsSeparators"></div>
                                        </div>
                                        <div class="col-12 margin_button_10">
                                          <div class="sectionUnderDescription">
                                            *for shrinkage use a negative value
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- STEP 6: NOTES & ACTIONS -->
                              <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(5)">
                                <div class="row">
                                  <div class="col-12">
                                    <p class="step_title" (click)="goToStep(5)">Step 6: <span class="stepDescription">notes & configuration</span></p>
                                  </div>
                                  <div class="col-12">
                                    <div class="bordered_sections_special bordered_sections_special_right minHeightSection"
                                      [class.active-step-forcast]="currentStep === 5" (click)="goToStep(5)">
                                      @if (currentStep !== 5) {
                                        <div class="forcast-overlay" (click)="goToStep(5)"></div>
                                      }
                                      <div class="row">
                                        <div class="col-12 margin_button_10">
                                          <label class="control-label trl" for="notes">Notes</label>
                                          <textarea [disabled]="currentStep != 5" class="k-textarea writebox note_textarea" rows="2"
                                          formControlName="notes" placeholder="Enter configuration notes..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- FORM VALIDATION SUMMARY -->
                        @if (invalidForm) {
                          <asap-forms-validation-summary [form]="form" [page]="'standardForecast'">
                          </asap-forms-validation-summary>
                        }
                        <!-- INLINE VISUALIZATION SECTION (GRID, MATRIX, CHART, VARIANCE & KPIS) -->
                        @if (previewMode) {
                          <div class="col-12" style="margin-top: 15px; padding: 0 10px;">
                            <div class="bordered_sections" style="margin: 0; padding: 15px; background-color: #ffffff;">
                              <!-- EXECUTIVE KPI SUMMARY CARDS -->
                              <div class="kpiCardsRow">
                                <div class="kpiCard kpiCardForecast">
                                  <div class="kpiLabel">Forecast Demand</div>
                                  <div class="kpiValue greenText">{{ formatQty(kpiSummary.totalForecastUnits) }} <span class="kpiUnit">units</span></div>
                                </div>
                                <div class="kpiCard kpiCardHistory">
                                  <div class="kpiLabel">Historical Volume</div>
                                  <div class="kpiValue orangeText">{{ formatQty(kpiSummary.totalHistoricalUnits) }} <span class="kpiUnit">units</span></div>
                                </div>
                                <div class="kpiCard kpiCardCost">
                                  <div class="kpiLabel">Estimated Cost</div>
                                  <div class="kpiValue">{{ formatCurrency(kpiSummary.totalEstimatedCost) }}</div>
                                </div>
                                <div class="kpiCard kpiCardRevenue">
                                  <div class="kpiLabel">Estimated Revenue</div>
                                  <div class="kpiValue">{{ formatCurrency(kpiSummary.totalEstimatedPrice) }}</div>
                                </div>
                                <div class="kpiCard kpiCardSkus">
                                  <div class="kpiLabel">SKUs Analyzed</div>
                                  <div class="kpiValue">{{ kpiSummary.totalSKUs }} <span class="kpiUnit">items</span></div>
                                </div>
                              </div>
                              <!-- 4-VIEW SWITCHER TOOLBAR & CONTROLS -->
                              <div class="viewToolbar">
                                <div class="toolbarLeft">
                                  <button kendoButton class="viewToggleBtn" [class.activeViewBtn]="activeViewMode === 'grid'" (click)="switchViewMode('grid')">
                                    <img [src]="'/assets/menu/' + (theme || 'enterprise') + '/view-icon.svg'" class="btnIcon" /> Detail Grid
                                  </button>
                                  <button kendoButton class="viewToggleBtn" [class.activeViewBtn]="activeViewMode === 'matrix'" (click)="switchViewMode('matrix')">
                                    <img [src]="'/assets/menu/' + (theme || 'enterprise') + '/view-icon.svg'" class="btnIcon" /> Monthly Matrix
                                  </button>
                                  <button kendoButton class="viewToggleBtn" [class.activeViewBtn]="activeViewMode === 'chart'" (click)="switchViewMode('chart')">
                                    <img [src]="'/assets/menu/' + (theme || 'enterprise') + '/view-graph-icon.svg'" class="btnIcon" /> Dual-Curve Chart
                                  </button>
                                  <button kendoButton class="viewToggleBtn" [class.activeViewBtn]="activeViewMode === 'variance'" (click)="switchViewMode('variance')">
                                    <img [src]="'/assets/menu/' + (theme || 'enterprise') + '/view-report-icon.svg'" class="btnIcon" /> Inventory Variance
                                  </button>
                                </div>
                                @if (activeViewMode === 'grid' || activeViewMode === 'matrix') {
                                  <div class="toolbarRight">
                                    <label class="toolbarCheck">
                                      <input type="checkbox" kendoCheckBox [checked]="filterForecasted" (change)="onFilterForecastedChange($event.target.checked)" />
                                      <span>Forecast Data</span>
                                    </label>
                                    <label class="toolbarCheck">
                                      <input type="checkbox" kendoCheckBox [checked]="filterHistory" (change)="onFilterHistoryChange($event.target.checked)" />
                                      <span>Historical Data</span>
                                    </label>
                                    <span class="divider">|</span>
                                    <label class="toolbarCheck">
                                      <input type="checkbox" kendoCheckBox [checked]="useConfigDecimals" (change)="onUseConfigDecimalsChange($event.target.checked)" />
                                      <span>Configured Decimals</span>
                                    </label>
                                    <span class="divider">|</span>
                                    <label class="toolbarCheck">
                                      <input type="checkbox" kendoCheckBox [checked]="hideZeroQty" (change)="onHideZeroQtyChange($event.target.checked)" />
                                      <span>Hide 0 Qty</span>
                                    </label>
                                  </div>
                                }
                                @if (activeViewMode === 'chart') {
                                  <div class="toolbarRight">
                                    <label class="toolbarCheck">
                                      <input type="checkbox" kendoCheckBox [checked]="displayTopTenItems" (change)="onTopTenSKUsToggle($event.target.checked)" />
                                      <span>Top 10 Items</span>
                                    </label>
                                    <kendo-multiselect [data]="skusForChartFilter" [textField]="'stockNumber'" [valueField]="'stockId'"
                                      [valuePrimitive]="true" [(ngModel)]="selectedSkusForChart" [ngModelOptions]="{standalone: true}"
                                      (valueChange)="onChartSKUFilterChange($event)" placeholder="Filter by Item(s)..." class="chartSkuSelect addNewForecastMS">
                                    </kendo-multiselect>
                                  </div>
                                }
                              </div>
                              <!-- VIEW 1: RESULTS GROUPED DETAIL KENDO GRID -->
                              @if (activeViewMode === 'grid') {
                                <div class="gridContainer" style="margin-top: 15px;">
                                  <kendo-grid [data]="gridData" [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
                                    [group]="gridState.group" [pageable]="true" [sortable]="true" [groupable]="true" [resizable]="true"
                                    (dataStateChange)="onGridDataStateChange($event)">
                                    <ng-template kendoGridToolbarTemplate>
                                      <button kendoGridExcelCommand type="button" icon="file-excel">Export to Excel</button>
                                    </ng-template>
                                    <kendo-grid-column field="stockNumber" title="Stock Name" [width]="180">
                                      <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                        <strong>Stock: {{ value }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="historyDate" title="Date" [width]="140">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatDate(dataItem.historyDate) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="qty" title="Qty" [width]="110">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.qty) }}
                                      </ng-template>
                                      <ng-template kendoGridGroupFooterTemplate let-aggregates>
                                        <strong>Sum: {{ formatQty($safeNavigationMigration(aggregates?.qty?.sum)) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="qtyPendingSO" title="Qty Pending SO" [width]="150">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.qtyPendingSO) }}
                                      </ng-template>
                                      <ng-template kendoGridGroupFooterTemplate let-aggregates>
                                        <strong>Sum: {{ formatQty($safeNavigationMigration(aggregates?.qtyPendingSO?.sum)) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="qtyPendingPO" title="Qty Pending PO" [width]="150">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.qtyPendingPO) }}
                                      </ng-template>
                                      <ng-template kendoGridGroupFooterTemplate let-aggregates>
                                        <strong>Sum: {{ formatQty($safeNavigationMigration(aggregates?.qtyPendingPO?.sum)) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="estimatedCost" title="Estimated Cost" [width]="145">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatCurrency(dataItem.estimatedCost) }}
                                      </ng-template>
                                      <ng-template kendoGridGroupFooterTemplate let-aggregates>
                                        <strong>Sum: {{ formatCurrency($safeNavigationMigration(aggregates?.estimatedCost?.sum)) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="estimatedPrice" title="Estimated Price" [width]="145">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatCurrency(dataItem.estimatedPrice) }}
                                      </ng-template>
                                      <ng-template kendoGridGroupFooterTemplate let-aggregates>
                                        <strong>Sum: {{ formatCurrency($safeNavigationMigration(aggregates?.estimatedPrice?.sum)) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentlyInStock" title="Qty On Hand" [width]="130">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.currentlyInStock) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentyStockSuggestedReorderQuantity" title="Suggested Reorder" [width]="160">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.currentyStockSuggestedReorderQuantity) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="forecasted" title="Data Source" [width]="140">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <span [class.badgeForecast]="dataItem.forecasted" [class.badgeHistory]="!dataItem.forecasted">
                                          {{ dataItem.forecasted ? 'Forecast' : 'Historical' }}
                                        </span>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-excel fileName="Forecast_Results.xlsx"></kendo-grid-excel>
                                  </kendo-grid>
                                </div>
                              }
                              <!-- VIEW 2: MONTH-BY-MONTH PIVOT / MATRIX KENDO GRID -->
                              @if (activeViewMode === 'matrix') {
                                <div class="gridContainer" style="margin-top: 15px;">
                                  <kendo-grid [data]="matrixGridData" [pageSize]="matrixGridState.take" [skip]="matrixGridState.skip"
                                    [pageable]="true" [sortable]="true" [resizable]="true" (dataStateChange)="onMatrixGridDataStateChange($event)">
                                    <ng-template kendoGridToolbarTemplate>
                                      <button kendoGridExcelCommand type="button" icon="file-excel">Export Matrix to Excel</button>
                                    </ng-template>
                                    <kendo-grid-column field="stockNumber" title="SKU Code" [width]="160">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <strong>{{ dataItem.stockNumber }}</strong>
                                        @if (dataItem.stockDescription) {
                                          <div class="skuDescSubtitle">{{ dataItem.stockDescription }}</div>
                                        }
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentlyInStock" title="On Hand" [width]="100">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.currentlyInStock) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    @for (col of matrixColumns; track col) {
                                      <kendo-grid-column [field]="col.field" [title]="col.title" [width]="115">
                                        <ng-template kendoGridHeaderTemplate>
                                          <div class="matrixColHeader" [class.forecastHeader]="col.isForecast" [class.historyHeader]="!col.isForecast">
                                            <span>{{ col.title }}</span>
                                            <span class="matrixColBadge" [class.badgeForecast]="col.isForecast" [class.badgeHistory]="!col.isForecast">
                                              {{ col.isForecast ? 'Forecast' : 'History' }}
                                            </span>
                                          </div>
                                        </ng-template>
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                          <span class="matrixQtyCell" [class.matrixQtyForecast]="col.isForecast" [class.matrixQtyHistory]="!col.isForecast">
                                            {{ formatQty(dataItem.monthlyValues[col.field] || 0) }}
                                          </span>
                                        </ng-template>
                                      </kendo-grid-column>
                                    }
                                    <kendo-grid-column field="totalForecastQty" title="Total Forecast" [width]="125">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <strong class="greenText">{{ formatQty(dataItem.totalForecastQty) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="totalEstimatedCost" title="Total Est. Cost" [width]="135">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatCurrency(dataItem.totalEstimatedCost) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-excel fileName="Forecast_Monthly_Matrix.xlsx"></kendo-grid-excel>
                                  </kendo-grid>
                                </div>
                              }
                              <!-- VIEW 3: RESULTS DUAL-SERIES CHART -->
                              @if (activeViewMode === 'chart') {
                                <div class="chartContainer" style="margin-top: 15px; padding: 10px 0;">
                                  <div class="chartLegendHint">
                                    <span class="legendBox orangeBox"></span> Historical Actuals (Orange)
                                    <span class="legendBox greenBox" style="margin-left: 20px;"></span> Forecast Projection (Green)
                                  </div>
                                  <kendo-chart [categoryAxis]="{ categories: chartCategories }" [title]="{ text: 'Forecast Projection (Historical Actuals vs Projected Demand)' }">
                                    <kendo-chart-tooltip [format]="'n0'"></kendo-chart-tooltip>
                                    <kendo-chart-series>
                                      @for (s of chartSeries; track s) {
                                        <kendo-chart-series-item [type]="s.type" [data]="s.data" [name]="s.name"
                                          [color]="s.color" [style]="s.style" [missingValues]="s.missingValues">
                                        </kendo-chart-series-item>
                                      }
                                    </kendo-chart-series>
                                  </kendo-chart>
                                </div>
                              }
                              <!-- VIEW 4: INVENTORY VARIANCE & REORDER RISK TABLE -->
                              @if (activeViewMode === 'variance') {
                                <div class="gridContainer" style="margin-top: 15px;">
                                  <kendo-grid [data]="varianceGridData" [pageSize]="varianceGridState.take" [skip]="varianceGridState.skip"
                                    [pageable]="true" [sortable]="true" [resizable]="true" (dataStateChange)="onVarianceGridDataStateChange($event)">
                                    <ng-template kendoGridToolbarTemplate>
                                      <button kendoGridExcelCommand type="button" icon="file-excel">Export Variance Analysis to Excel</button>
                                    </ng-template>
                                    <kendo-grid-column field="stockNumber" title="SKU Code" [width]="160">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <strong>{{ dataItem.stockNumber }}</strong>
                                        @if (dataItem.stockDescription) {
                                          <div class="skuDescSubtitle">{{ dataItem.stockDescription }}</div>
                                        }
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentlyInStock" title="Live On Hand" [width]="115">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.currentlyInStock) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="qtyPendingPO" title="Inbound PO" [width]="115">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.qtyPendingPO) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="qtyPendingSO" title="Allocated SO" [width]="115">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ formatQty(dataItem.qtyPendingSO) }}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="netAvailableStock" title="Net Available" [width]="125">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <strong>{{ formatQty(dataItem.netAvailableStock) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="totalForecastDemand" title="Forecast Demand" [width]="135">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <span class="greenText" style="font-weight: 600;">{{ formatQty(dataItem.totalForecastDemand) }}</span>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="projectedEndingStock" title="Projected Ending Stock" [width]="165">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <span [class.criticalStockText]="dataItem.projectedEndingStock < 0" [class.healthyStockText]="dataItem.projectedEndingStock >= 0" style="font-weight: 600;">
                                          {{ formatQty(dataItem.projectedEndingStock) }}
                                        </span>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="suggestedReorderQty" title="Suggested Reorder" [width]="150">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <strong [class.orangeText]="dataItem.suggestedReorderQty > 0">{{ formatQty(dataItem.suggestedReorderQty) }}</strong>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="stockStatus" title="Status Risk" [width]="140">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <span class="statusBadge" [class.statusHealthy]="dataItem.stockStatus === 'healthy'" [class.statusWarning]="dataItem.stockStatus === 'warning'" [class.statusCritical]="dataItem.stockStatus === 'critical'">
                                          {{ dataItem.stockStatusLabel }}
                                        </span>
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-excel fileName="Forecast_Inventory_Variance.xlsx"></kendo-grid-excel>
                                  </kendo-grid>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                      <!-- DOCKED ACTION FOOTER (ALWAYS VISIBLE WITHOUT SCROLLING) -->
                      <div class="forecast-form-footer">
                        <button kendoButton class="steps_buttons_class" (click)="closeForm()">
                          <img class="backimage" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        <button [disabled]="!canSave()" kendoButton class="steps_buttons_class" (click)="saveForecast(true)">
                          <img class="backimage" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/save-icon-group.svg'" />
                          <span>save and close</span>
                        </button>
                        <button [disabled]="!canSave()" kendoButton class="steps_buttons_class" (click)="saveForecast(false)">
                          <img class="backimage" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/save-icon-group.svg'" />
                          <span>save</span>
                        </button>
                        <button [disabled]="!canSave()" kendoButton class="steps_buttons_class" (click)="openInReportViewer()">
                          <img class="backimage" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/stock-report-icon.svg'" />
                          <span>report viewer</span>
                        </button>
                      </div>
                    </form>
                  </kendo-window>
                }
